exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.hb-check-platform-page .desc[data-v-a2cc10f8]{color:red;size:20px;width:100%;text-align:center;padding:30px\n}", "", {"version":3,"sources":["C:/Users/Administrator/Documents/hbt-ielts-client-pc-web/src/components/checkPlatform/index.vue"],"names":[],"mappings":";AACA,+CAA+C,UAAU,UAAU,WAAW,kBAAkB,YAAY;CAC3G","file":"index.vue","sourcesContent":["\n.hb-check-platform-page .desc[data-v-a2cc10f8]{color:red;size:20px;width:100%;text-align:center;padding:30px\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2cc10f8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkPlatform/index.vue
// module id = wM3x
// module chunks = 1